export const file = {
  strict: true, // true => strict update state from component

  state: {
    upload: null,
    uploading: false,
    uploadConfirmed: false,
    uploadedFiles: [],
  },

  getters: {},

  mutations: {
    OPEN_UPLOAD: (state, payload) => {
      state.upload = {
        cid: payload.cid,
        members: payload.members,
      };
    },
    CLOSE_UPLOAD: (state, payload) => {
      state.upload = null;
    },
    UPLOADING: (state, payload) => {
      state.uploading = payload;
    },
    APPEND_UPLOADED: (state, payload) => {
      state.uploadedFiles.push(payload);
    },
    CLEAR_UPLOADED: (state, payload) => {
      state.uploadedFiles = [];
    },
    UPLOAD_CONFIRM: (state, payload) => {
      state.uploadConfirmed = payload;
    },
  },
};
